// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__c0Q1z","center":"Footer_center__DNAZo","left":"Footer_left__JQ1mJ","icons":"Footer_icons__JfHkL"};